import { mapActions, mapGetters, mapMutations } from 'vuex'
import validationMixin from '@/mixins/validation'
import { debounce, snakeCase } from 'lodash'
import { userCourseAccessListTableHead } from '../../helpers'
import {UPDATE} from '../../../../../store/modules/user/types/action-types';

export default {
  name: 'user-admins-courses',
  mixins: [validationMixin],
  data () {
    return {
      valid: false,
      validUpdateProgressForm: false,
      page: 1,
      showDialogCourse: false,
      showRemoveDialog: false,
      showDialogUpdateProgress: false,
      validFormCourse: false,
      deletedItemData: null,
      editedItem: null,

      keywords: '',
      payload: {
        courseId: '',
      },
      progressForm: {
        userId: this.$route.params.id,
        moduleId: '',
        packageId: '',
        courseId: '',
        courseUserId: '',
        id: ''
      },

      search: null,
      searchInput: null
    }
  },
  computed: {
    ...mapGetters({
      userCourses: 'userCoursesAccess/userCourses',
      userCoursesLength: 'userCoursesAccess/userCoursesLength',
      isUserCoursesLoading: 'userCoursesAccess/isUserCoursesLoading',
      limit: 'userCoursesAccess/limit',
      skip: 'userCoursesAccess/skip',
      isLoading: 'userCoursesAccess/isLoading',

      courses: 'userCoursesAccess/courses',
      isCoursesLoading: 'userCoursesAccess/isCoursesLoading',
      packagesCourse: 'userCoursesAccess/packagesCourse',
      isPackagesCourseLoading: 'userCoursesAccess/isPackagesCourseLoading',

      courseModules: 'courses/courseModules',
      courseModulesLoading: 'courses/courseModulesLoading',
      courseMaterials: 'courses/courseMaterials',
      courseMaterialsLoading: 'courses/courseMaterialsLoading'
    }),
	  userCourseAccessListTableHead
  },
  created () {
    if (!this.userCourses.length) {
      this.fetchUserCourses({
        userId: this.$route.params.id,
        keywords: this.keywords
      })
    }
    if (this.userCourses) {
      if (this.skip !== 0) {
        this.page = Math.round(this.skip / this.limit) + 1
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCourses: 'userCoursesAccess/GET_COURSES',
      fetchPackages: 'userCoursesAccess/PACKAGES_GET_LIST',
      fetchUserCourses: 'userCoursesAccess/GET_USER_COURSES',
      fetchCourseModules: 'courses/GET_COURSE_MODULES',
      fetchCourseMaterials: 'courses/GET_COURSE_MATERIALS',
      remove: 'userCoursesAccess/DELETE',
      update: 'userCoursesAccess/UPDATE',
      // update: 'userCourses/UPDATE_COURSE_SUCCESS',
      updateProgress: 'userCoursesAccess/UPDATE_PROGRESS',
      create: 'userCoursesAccess/CREATE'
    }),
    ...mapMutations({
      changeSkip: 'userCoursesAccess/USER_COURSES_CHANGE_SKIP',
      setUserCourses: 'userCoursesAccess/SET_USER_COURSES',
      setCourses: 'userCoursesAccess/SET_COURSES',
      setPackages: 'userCoursesAccess/PACKAGES_SET_LIST'
    }),

    changeInputCourse: debounce(function (val) {
      if (!val) return
      if (this.keywords !== val) {
        this.keywords = val
        this.fetchCourses({
          keywords: val,
          id: this.payload.courseId
        })
      }
    }, 500),
    autoCompleteChanged (e) {
      this.setPackages([])
      this.payload.courseId = e.id
      this.search = e
      this.fetchPackages({ courseId: e.id })
    },
    // end //
    changeDialogCourse (item = null, status = false) {
      this.setPackages([])
      this.showDialogCourse = status
      this.editedItem = item
      if (status) {
        if (item) {
          this.payload.packageId = item.package.data.id
          this.fetchPackages({ courseId: item.course.data.id })
        } else {
          this.setCourses([])
          this.fetchCourses({ keywords: '' })
        }
      } else {
        this.payload.courseId = ''
        this.payload.packageId = ''
        this.search = null
        this.searchInput = null
      }
    },

    removeItem () {
      this.remove({
        userId: this.$route.params.id,
        id: this.deletedItemData.id
      }).then(() => {
        this.showRemoveDialog = false
        this.$toasted.success(this.$t('success_deleted'))
      })
    },
    changeDialogDelete (item = null) {
      this.showRemoveDialog = !!item
      this.deletedItemData = item
    },
    changeDialogUpdateProgress (status = false, item = null) {
      this.showDialogUpdateProgress = status
      this.progressForm.userId = this.$route.params.id
      if (item) {
        // eslint-disable-next-line camelcase
        const { id, module_id } = item.currentMaterial.data
        this.progressForm.courseUserId = item.id
        this.progressForm.courseId = item.course_id
        this.progressForm.moduleId = module_id
        this.progressForm.id = id
        this.progressForm.packageId = item.package_id

        if (item.currentMaterial.data.hasOwnProperty('id')) {
          this.fetchCourseMaterials(this.progressForm)
        }
        this.fetchCourseModules(this.progressForm)
      } else {
        Object.keys(this.progressForm).forEach(e => {
          this.progressForm[e] = ''
        })
      }
    },
    updateProgressCourse () {
      this.$refs.updateProgressForm.validate()
      if (this.validUpdateProgressForm) {
        this.progressForm.lesson_id = this.progressForm.id
        this.updateProgress(this.progressForm).then(() => {
          this.$toasted.success(this.$t('success_updated'))
          this.changeDialogUpdateProgress()
          this.fetchUserCourses({
            userId: this.$route.params.id,
            keywords: this.keywords
          })
        })
      }
    },
    changePagination (index) {
      this.changeSkip(this.limit * (index - 1))
      this.$vuetify.goTo(0)
      this.fetchUserCourses({ userId: this.$route.params.id })
    },
    createRequestPayload () {
      const formData = {}
      for (const i in this.payload) {
        formData[snakeCase(i)] = this.payload[i]
      }
      formData.userId = this.$route.params.id
      if (this.editedItem) {
        formData._method = 'patch'
        formData.id = this.editedItem.id
      }
      return formData
    },
    submit () {
      this.$refs.formCourse.validate()
      if (this.validFormCourse) {
        if (this.editedItem) {
          this.update(this.createRequestPayload()).then(() => {
            this.$toasted.success(this.$t('success_updated'))
            this.changeDialogCourse()
          })
        } else {
          this.create(this.createRequestPayload()).then(() => {
            this.$toasted.success(this.$t('success_created'))
            this.changeDialogCourse()
          })
        }
      }
    }
  },
  destroyed () {
    this.setUserCourses([])
  }
}
